module.exports = __webpack_public_path__ + "static/media/eppan.ebe61f92.jpeg";